import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
    GetPollParserByIdDto,
    PollParserResponse,
    SendTypes,
} from '../../../../../core/api/models';
import { CreatePollParserCommand } from '../../../../../core/api/models/create-poll-parser-command';
import { GetEnumValuesDto } from '../../../../../core/api/models/get-enum-values-dto';
import { PollParserResponseType } from '../../../../../core/api/models/poll-parser-response-type';
import { PollParserType } from '../../../../../core/api/models/poll-parser-type';
import { SurveyParserService } from '../../../../../core/api/services/survey-parser.service';
import { PeriodicDateTimeConfig } from '../../../../../shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { BaseParserFormComponent } from '../../base-parser/base-parser-form.component';
import { UpdatePollParserCommand } from './../../../../../core/api/models/update-poll-parser-command';
import { FormPageConfig } from './../../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';

@Component({
    selector: 'app-survey-parser-form-page',
    templateUrl: './survey-parser-form-page.component.html',
    styleUrls: ['./survey-parser-form-page.component.scss'],
    imports: [BaseFormModule, SmsBodyModule]
})
export class SurveyParserFormPageComponent
  extends BaseParserFormComponent
  implements OnInit
{
  //#region properties

  periodicDateTimeConfig: PeriodicDateTimeConfig;
  model: CreatePollParserCommand = {};
  formPageConfig: FormPageConfig<GetPollParserByIdDto> = {};

  formulasForm: FormGroup;
  responsesForm: FormGroup;

  optionTitle: string = '';
  keyword: string = '';
  selectedPhonebookId: number;
  selectedPhonebookName: string;
  isCorrect: boolean = false;

  responses?: Array<PollParserResponse>;

  get PollParserType() {
    return PollParserType;
  }
  get PollParserResponseType() {
    return PollParserResponseType;
  }
  get SendTypes() {
    return SendTypes;
  }

  PollParserResponseTypeEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(protected currentService: SurveyParserService) {
    super();
  }

  ngOnInit() {
    try {
      this.model.type = PollParserType.Survey;
      super.ngOnInit();
      this.responses = JSON.parse(JSON.stringify(this.model.responses));
      ConsoleService.info('res', this.responses);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#region api

  baseCreateApi(model: CreatePollParserCommand) {
    this.unSubs();
    this.loading = true;

    model.type = PollParserType.Survey;
    this.currentService
      .surveyParserCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: UpdatePollParserCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .surveyParserUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
